import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DatePicker } from "@/components/DatePicker";

const STATUSES = ["all", "pending", "confirmed", "completed", "cancelled"];

export const Filters = ({ filters, setFilters, todayDate }) => {
  const set = (k, v) => setFilters({ ...filters, [k]: v });
  return (
    <div className="flex flex-col xl:flex-row gap-3 xl:items-center justify-between">
      <Tabs value={filters.status} onValueChange={(v) => set("status", v)}>
        <TabsList className="flex-wrap h-auto">
          {STATUSES.map((s) => (
            <TabsTrigger key={s} value={s} className="capitalize" data-testid={`filter-status-${s}`}>{s}</TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative">
          <Search className="absolute left-3 top-3.5 h-4 w-4 text-muted-foreground" />
          <Input placeholder="Search name, phone, ref" className="pl-9 h-11 sm:w-60" value={filters.q} onChange={(e) => set("q", e.target.value)} data-testid="filter-search-input" />
        </div>
        <div className="sm:w-56"><DatePicker value={filters.date} onChange={(d) => set("date", d)} testid="filter-date-picker" allowPast /></div>
        <Button variant="outline" className="h-11" onClick={() => set("date", todayDate)} data-testid="filter-today-btn">Today</Button>
        {(filters.date || filters.q || filters.status !== "all") && (
          <Button variant="ghost" className="h-11" onClick={() => setFilters({ status: "all", date: "", q: "" })} data-testid="filter-clear-btn"><X className="mr-1 h-4 w-4" /> Clear</Button>
        )}
      </div>
    </div>
  );
};
